<template>
  <div 
    style="width: 100%; max-width: 500px; padding: 0 16px;"
    :style="[ isHeaderFixed ? {position: 'fixed'} : {position: 'relative'}]"
  >
    <!-- :class="{'header-fixed': isHeaderFixed}" -->
    <v-row wrap>
      <v-flex xs7>
        <div class="ml-3 mt-5">
          <template v-if="subpageLogoColor && subpageLogoColor == 'black'">
            <img width="180px" src="@/assets/images/logo-black.png" />
          </template>
          <template v-else-if="subpageLogoColor && subpageLogoColor == 'white'">
            <img width="120px" src="@/assets/images/logo-white.png" />
          </template>
          <template v-else>
            <img width="180px" src="@/assets/images/logo.png" />
          </template>
        </div>
      </v-flex>
      <v-flex xs5>
        <div class="text-right" v-if="hasMenu">
          <v-menu
            bottom
            left
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                fab
                text
                v-bind="attrs"
                v-on="on"
                :ripple="false"
              >
                <div class="btn-menu" :class="{'btn-white': !isMenuBlack}">
                  <div class="bar1"></div>
                  <div class="bar2"></div>
                  <div class="bar3"></div>
                </div>
              </v-btn>
            </template>
            <v-card>
              <v-list-item-group>
                <template v-for="(item, i) in menus">
                  <template v-if="!isMember">
                    <template v-if="!item.showMember">
                      <v-list-item
                        :key="i"
                        link
                        @click="changePage(item.path)"
                        class="Kanit"
                      >
                        <v-list-item-avatar :tile="true">
                          <img :src="item.icon" style="height: 20px; width: auto;"/>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider
                          v-if="i < menus.length - 1"
                          :key="`${i}-divider`"
                          style=""
                      ></v-divider>
                    </template>
                  </template>
                  <template v-else >
                    <template v-if="item.showMember">
                      <v-list-item
                        :key="i"
                        link
                        @click="changePage(item.path)"
                        class="Kanit"
                      >
                        <v-list-item-avatar :tile="true">
                          <img :src="item.icon" style="height: 20px; width: auto;"/>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider
                          v-if="i < menus.length - 1"
                          :key="`${i}-divider`"
                          style=""
                      ></v-divider>
                    </template>
                  </template>
                </template>
              </v-list-item-group>
            </v-card>
          </v-menu>
        </div>
      </v-flex>
    </v-row>
  </div>
    
    
    <!-- <v-app-bar-nav-icon @click="drawer = true"></v-app-bar-nav-icon> -->
    <!-- <div class="text-right">
      <v-btn
        fab
        text
        :ripple="false"
        @click="drawer = true"
      >
        <div class="btn-menu">
          <div class="bar1"></div>
          <div class="bar2"></div>
          <div class="bar3"></div>
        </div>
      </v-btn>
    <v-navigation-drawer
      v-model="drawer"
      absolute
      right
    >
      <v-btn
        fab
        text
        class="menu-active"
        :ripple="false"
        @click="drawer = false"
      >
        <div class="btn-menu">
          <div class="bar1"></div>
          <div class="bar2"></div>
          <div class="bar3"></div>
        </div>
      </v-btn>
      <v-list
        nav
        dense
      >
        <v-list-item-group
          v-model="group"
          active-class="deep-purple--text text--accent-4"
        >
          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-home</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item>

          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Account</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    </div> -->
</template>

<script>
  export default {
   props: {
      isHeaderFixed: {
        type: Boolean,
        default: true
      },
      isMenuBlack: {
        type: Boolean,
        default: true
      },
      subpageLogoColor: {
        type: String,
        default: null
      },
      hasMenu: {
        type: Boolean,
        default: true
      },
    },
    data() {
      return {
        menus: [
          { title: 'หน้าแรก',
            icon: require("../assets/images/menu-icon-home.png"),
            path: 'home',
            showMember: false,
          },
          { title: 'LAMY CLUB คืออะไร',
            icon: require("../assets/images/menu-icon-lamy-club.png"),
            path: 'about',
            showMember: false,
          },
          { title: 'ข้อกำหนดและเงื่อนไข',
            icon: require("../assets/images/menu-icon-term.png"),
            path: 'term',
            showMember: false,
          },
          { title: 'สิทธิประโยชน์สมาชิก',
            icon: require("../assets/images/menu-icon-benefits.png"),
            path: 'benefits-information',
            showMember: false,
          },
          { title: 'ข้อมูลของฉัน',
            icon: require("../assets/images/menu-icon-profile.png"),
            path: 'profile',
            showMember: true,
          },
          { title: 'รางวัลของฉัน',
            icon: require("../assets/images/menu-icon-my-benefits.png"),
            path: 'benefits',
            showMember: true,
          },
          { title: 'สะสมยอดซื้อ',
            icon: require("../assets/images/menu-icon-home.png"),
            path: 'accumulate',
            showMember: true,
          },
          { title: 'สิทธิประโยชน์สมาชิก',
            icon: require("../assets/images/menu-icon-benefits.png"),
            path: 'benefits-information',
            showMember: true,
          },
          { title: 'บริการห่อของขวัญ',
            icon: require("../assets/images/menu-icon-gift.png"),
            path: 'gift-wrap',
            showMember: false,
          },
          { title: 'บริการแกะสลัก',
            icon: require("../assets/images/menu-icon-craving.png"),
            path: 'craving',
            showMember: false,
          },
          
         
        ],
        drawer: false,
        group: null,
        isMember: false,
      };
    },
    mounted() {
      if(Object.keys(this.member).length > 0) {
        this.isMember = true;
      }
    },
    computed: {
      member() {
        return this.$store.state.member;
      }
    },
    methods: {
      isActive(x) {
        x.classList.toggle("change");
      },
      changePage(name) {
        var path = "/"+name;
        if (this.$route.path !== path) {
          this.$router.push({
            path: name,
            query: {...this.$route.query } ,
          }).catch({});
        }
      },
    },
    watch : {
      member(newval,oldval) {
        if(newval != oldval) {
          this.isMember = true;
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.btn-menu {
  .bar1, .bar2, .bar3 {
    width: 35px;
    height: 5px;
    background-color: #333;
    margin: 6px 0;
    transition: 0.4s;
  }
}
.btn-white {
  .bar1, .bar2, .bar3 {
    background-color: rgba(255,255,255,0.7) !important;
  }
}
.v-btn[aria-expanded='true']{
  .bar1 {
    -webkit-transform: rotate(-45deg) translate(-9px, 6px);
    transform: rotate(-45deg) translate(-9px, 6px);
  }
  .bar2 {opacity: 0;}

  .bar3 {
    -webkit-transform: rotate(45deg) translate(-9px, -8px);
    transform: rotate(45deg) translate(-9px, -8px);
  }
}
// .menu-active{
//   .bar1 {
//     -webkit-transform: rotate(-45deg) translate(-9px, 6px);
//     transform: rotate(-45deg) translate(-9px, 6px);
//   }
//   .bar2 {opacity: 0;}

//   .bar3 {
//     -webkit-transform: rotate(45deg) translate(-9px, -8px);
//     transform: rotate(45deg) translate(-9px, -8px);
//   }
// }
.theme--light.v-btn:focus::before {
    opacity: 0 !important;
}
.v-list-item__icon {
  margin-right: 16px !important;
}
</style>